import { styled } from "@mui/material/styles";

const FilterButtonMain = styled("div")(({ theme, width }) => ({
  margin: "0 auto",
  width: width ? "90%" : "60%",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  borderBottom: "2px solid #D9D9D9",
  marginTop: "30px",
  [theme.breakpoints.down("md")]: {
    width: "100%",
  },
  "& button": {
    backgroundColor: "transparent",
    border: "none",
    position: "relative",
    borderRadius: "inherit",
    position: "relative",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "20px",
    lineHeight: "27px",
    textAlign: "center",
    color: "#AAAAAA",
    textTransform: "capitalize",
    paddingBottom: "8px",
    "&:hover": { backgroundColor: "transparent" },
    "&.active": {
      "&:after": {
        content: "''",
        position: "absolute",
        bottom: "-2px",
        width: "100%",
        borderBottom: "2px solid #0B0B0B",
      },
      color: "#0B0B0B",
    },
  },
}));

export { FilterButtonMain };
